var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_3019)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60836 1.52902C9.67504 0.462333 11.4045 0.462333 12.4712 1.52902C13.5378 2.5957 13.5378 4.32513 12.4712 5.39181L6.93807 10.9249C6.62195 11.241 6.43586 11.4271 6.22884 11.5886C5.98483 11.7789 5.72081 11.9421 5.44146 12.0752C5.20445 12.1882 4.95477 12.2714 4.53063 12.4128L2.58747 13.0605L2.11959 13.2165C1.7401 13.343 1.3217 13.2442 1.03885 12.9613C0.755987 12.6785 0.657218 12.2601 0.783717 11.8806L1.58739 9.46956C1.72876 9.0454 1.81197 8.79572 1.92493 8.55871C2.05806 8.27936 2.22123 8.01534 2.41155 7.77134C2.57303 7.56431 2.75913 7.37822 3.07529 7.06209L8.60836 1.52902ZM2.56729 12.1449L4.22484 11.5924C4.68633 11.4385 4.8824 11.3724 5.06502 11.2854C5.287 11.1796 5.4968 11.0499 5.6907 10.8987C5.85021 10.7743 5.99707 10.6285 6.34104 10.2845L10.7566 5.86897C10.2965 5.70671 9.70386 5.40595 9.14904 4.85113C8.59422 4.29631 8.29346 3.70365 8.13121 3.24361L3.71568 7.65914C3.37171 8.00311 3.22592 8.14996 3.1015 8.30948C2.95027 8.50338 2.8206 8.71317 2.71481 8.93516C2.62778 9.11777 2.56162 9.31385 2.4078 9.77533L1.85528 11.4329L2.56729 12.1449ZM8.84095 2.53386C8.8609 2.63592 8.89462 2.77466 8.95089 2.93685C9.07757 3.30199 9.31686 3.78152 9.76776 4.23241C10.2187 4.68331 10.6982 4.92261 11.0633 5.04929C11.2255 5.10556 11.3643 5.13927 11.4663 5.15922L11.8524 4.77309C12.5774 4.04812 12.5774 2.87271 11.8524 2.14773C11.1275 1.42276 9.95205 1.42276 9.22708 2.14773L8.84095 2.53386Z",
    fill: "#3B3F48",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_3019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.d783d867c9220e2fc2a3cdc7fd313d40.svg";
export { ForwardRef as ReactComponent };